import { Box, Grid } from "@mui/material";
import afinazone from "assets/iconos/afinazone.png";
import { useHistory, useParams, useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";

export default function CarsBrandItem({ name, url, disabled }) {
  const { path } = useRouteMatch();
  const { typeSlug } = useParams();
  let history = useHistory();

  const redirectToBrandModels = () => {
    if(disabled)
      return;

    const newPath = path.replace(":typeSlug", typeSlug);
    history.push(`${newPath}/${name}`);
  };
  
  return (
    <Grid item xs={4} lg={3} onClick={redirectToBrandModels}>
      <div
        style={{
          width: "100%",
          paddingBottom: "10%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          componen="span"
          sx={{
            fontSize: { xs: "12px", md: "20px" },
          }}
          style={{
            marginBottom: "15px",
          }}
        >
          {name}
        </Box>
        <img
          src={url !== null ? url : afinazone}
          alt="marca"
          style={{
            height: "70%",
            width: "70%",
            cursor: disabled ? " " : "pointer",
          }}
          className={disabled ? "" : "zoom-on-hover"}
        />
      </div>
    </Grid>
  );
}
